<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activeModal">
    <div class="modal-dialog help-modal" role="document">
        <button type="button" class="close btn-black-close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"></button>
        <div class="modal-content">

            <div class="modal-header">
                <h2 class="help-header">Welcome to ClearFluency!</h2>
            </div>

            <div class="modal-body text-sm-center">
                <video class="tutorial-video" controls autoplay #helpVideoPlayer>
                    <source src="{{source}}" type="video/mp4">
                    Your browser does not support HTML5 video.
                </video>
            </div>

            <div class="modal-footer">
                <h5>Watch this short tutorial on how to use ClearFluency.</h5>
                <h5>You can access it again at any time from Tools menu.</h5>
            </div>

        </div>
    </div>
</div>
<div class="modal-backdrop fade in" *ngIf="activeModal"></div>
